export const EnumCateogy: { [key: string]: string } = {
  condolence: "상조",
  lifeGoods: "생전 ∙ 유품정리",
  inheritance: "상속상담",
  landClearing: "벌초 대행",
  tombConstruction: "묘 조성",
  funeral: "이장 ∙ 개장",
  memorialPark: "추모공원",
};
